
export const CarouselData = [
  {
    image:
      'https://ik.imagekit.io/0qlf5pqwx/20944961.jpg?updatedAt=1681306835316',
    captionHeader: 'Effortless Medical Tracking',
    captionText: 'Keep all your medical data organized in one place with our easy-to-use medical tracker. Store your tablets info, doctor appointments, and prescriptions with just a few clicks.',
  },
  {
    image:
      'https://ik.imagekit.io/0qlf5pqwx/73z_2202_w009_n001_113b_p14_113.jpg?updatedAt=1681306834771',
    captionHeader: 'Manage your health information with ease',
    captionText: 'Our medical dashboard provides you with a comprehensive view of your health data, including your medical history, tablets info, and appointment schedule. With our easy-to-read charts and graphs, you can quickly monitor your progress and stay on top of your health goals.',
  },
  {
    image:
      'https://ik.imagekit.io/0qlf5pqwx/1268.jpg?updatedAt=1681306834117',
    captionHeader: 'Personalized Healthcare for You',
    captionText: 'Search for experienced doctors who are dedicated to providing you with the best medical care possible.',
  },
];